import { useMutation, useQueryClient } from 'react-query';
import { API } from '../../../utils/ApiClient';

function useDeleteDiscount() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id }: { id?: string }) => API.delete('/discounts/' + id),
        onSuccess() {
            queryClient.invalidateQueries('discounts');
        },
    });
}

export default useDeleteDiscount;
